import { render, staticRenderFns } from "./LinesOfActivity.vue?vue&type=template&id=2b2d0b31&"
import script from "./LinesOfActivity.vue?vue&type=script&lang=js&"
export * from "./LinesOfActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports